<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="!!backButtonRoute"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
    class="stock-transfer-v2"
  >
    <slot></slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode === 'create'
            ? 'Create Stock Transfer'
            : 'Stock Transfer # ' + baseView.id
        "
        :secondaryLabel="undefined"
        v-if="loaded"
      />
    </template>

    <div v-if="loaded" class="css-v2 transaction-screen">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? model : {}"
          :itemSaveCallBack="saveTransaction"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="header-form-container">
          <div class="header-form">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="getHeaderFormItems"
                :isNormal="true"
                :data-model="loaded ? model : {}"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-form'"
                ref="gc-header-form"
                :checkValid="isValid"
                :validationGroup="'gc-header-form'"
                :scrollingEnabled="false"
                :formContentReady="formContentReady"
                :formHeight="100"
              ></gc-form>
            </div>
          </div>

          <div class="header-comments">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="getCommentsFormItems"
                :isNormal="true"
                :data-model="loaded ? model : {}"
                :deliveryAddressClicked="undefined"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-comments'"
                ref="gc-header-comments"
                :checkValid="isValid"
                :validationGroup="'gc-header-comments'"
                :scrollingEnabled="true"
                :formHeight="100"
              ></gc-form>
            </div>
          </div>
        </div>
      </div>

      <div class="gc-data-grid-so-v5">
        <dx-data-grid
          :data-source="dataSourceProductEntry"
          :columns="getColumns"
          :height="getGridHeight - 20"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          @toolbar-preparing="onToolbarPreparing($event)"
          @content-ready="onContentReady"
          @saved="onSaved"
          :on-row-removed="onRowRemoved"
          @editor-preparing="onEditorPreparing"
          v-if="loaded"
          @editing-start="onEditingStart"
          @focused-cell-changing="onFocusedCellChanging"
          @cell-prepared="onCellPrepared"
          @row-prepared="onRowPrepared"
        >
          <DxEditing
            :allow-deleting="baseView.mode !== 'review'"
            :allow-updating="baseView.mode !== 'review'"
            :mode="'cell'"
            :changes="changes"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />

          <DxPaging :page-size="200" :enabled="false" />

          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
            class="gc-pager"
            cssClass="gc-pages-2"
          />

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
          <template #DecimalCell="{ data }">
            <GcDecimalCell :dataValue="data" :format="data.column.format" />
          </template>
          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: lineItem }">
            <dx-data-grid
              :data-source="lineItem.data.ChildDataSource"
              :columns="getChildGridColumns(lineItem)"
              :columnChooser="{
                enabled: false,
              }"
              :searchPanel="{
                visible: false,
              }"
              :pager="{ visible: false }"
              :ref="'master-details-' + lineItem.data.ID"
              :elementAttr="{ class: 'internal-grid' }"
              :focusedRowEnabled="true"
              :key-expr="'BatchLineNo'"
              :on-row-removed="onBatchRowRemoved"
              @editing-start="onBatchEditingStart"
              @cell-prepared="onBatchCellPrepared"
              @focused-cell-changed="onBatchFocusedCellChanged"
              @editor-preparing="onBatchEditorPreparing"
              @row-prepared="onRowPrepared"
            >
              <DxEditing
                :allow-updating="baseView.mode !== 'review'"
                :allow-deleting="baseView.mode !== 'review'"
                mode="cell"
              />

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>

      <GcFooter v-if="showFooter && loaded">
        <template #leftContent>
          <div
            class="gc-grid-footer-item left-content"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType === 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format === 'Decimal-16-4C' ? 8 : 4"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format === 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <!-- Product Search Popup  -->
    <GcPopUpSearchForMultipleItem
      :setVisible="visibleProductSearch"
      :popupHiddenCallBack="onProductSearchHidden"
      :columns="getProductSearchColumns"
      :dataSource="getProductSearchDataSource"
      :setSelectedProducts="setSelectedProducts"
      v-if="visibleProductSearch"
    />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { getFactorByCode } from "@/_store/helpers";
import { mapGetters } from "vuex";
import { BranchService } from "@/_services/api/sales/branch.service";
import { ProductService } from "@/_services/api/products/product.service";
import ArrayStore from "devextreme/data/array_store";
import { StockTransferService } from "@/_services/api/inventory/stock-transfer-service";
import {
  backwardTabbing,
  forwardTabbing,
  onEnter,
} from "@/_helpers/ui/keyboard";
import FooterItemConfig from "@/_helpers/data-grid/footer-items";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { formatNumber } from "devextreme/localization";

const { getFooterLeftItems, getFooterRightItems } = FooterItemConfig;

let productEntryBase = {
  ProductCode: undefined,
  ProductDescription1: undefined,
  IsBatchProduct: "No",
  BranchCode: undefined,
  ChildDataSource: new ArrayStore({
    key: "BatchLineNo",
    data: [],
  }),
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: 0,
  TransferQty: 0,
  // AdjustmentQuantity: 0,
  Comment: "",
  LineNo: 0,
  StockEnquiryQuantities: [],
  IsValid: true,
};

let batchItemBase = {
  AllocatedQty: 0,
  AvailableQty: 0,
  BatchLineNo: 0,
  BatchNo: "",
  BestBeforeDate: undefined,
  BestBeforeShelfLife: 0,
  FromBatchDB: false,
  IsBatchProduct: undefined,
  IsManufacturedDateRequired: 0,
  ManufacturedDate: undefined,
  OnHand: 0,
  ParentID: null,
  ProductCode: null,
  ProductDescription1: undefined,
  SupplierBatchNo: "",
  SupplierCode: "",
  Transfer: 0,
  UseByDate: undefined,
  UseByShelfLife: 0,
  IsValid: true,
  tabKey: false,
};

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      model: {
        Status: "N",
        FriendlyStatus: undefined,
        // toFriendlyStatus: "N",
        DateIn: new Date(),
        Code: null,
        // DateIn: null,
        BranchCode: null,
        ToBranchCode: null,
        NextStatus: "C",
        ConsignmentNo: "",
        DeliveryAddressCompanyName: "",
        DeliveryAddressCountry: "",
        DeliveryAddressPostcode: null,
        DeliveryAddressState: "",
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        StockTransferDetails: [],
        // Status: "",
        RequiredByDate: null,
        PartDeliver: "N",
        NoBackorder: "N",
        SalesRepresentativeCode: "",
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        BranchDescription: undefined,
      },
      isValid: false,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },
      branchDataSourceItems: [],
      ellipsisMenu: [],
      loaded: false,
      showFooter: true,
      footerItems: [],
      changes: [],
      dataSourceProductEntry: new ArrayStore({
        key: "ID",
        data: [],
      }),
      productDataSourceItems: [],
      validationLineKey: undefined,
      validationDataField: undefined,
      searchForItem: {},
      selectedProduct: undefined,
      headerFormHeight: 0,
      visibleProductSearch: false,
      BatchGridInstance: undefined,
      IsBatchAvailable: false,
      expandChildGrid: true,
      gridDataLoaded: false,
    };
  },
  async created() {
    this.showLoading(true);

    await this.$store.dispatch("reportPdfPreview/setReportPreviewScreens");
    // this.$store.dispatch("dataContext/setDataViewType", "general-ledger");
    await this.initialized();
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },
  watch: {
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineKey) {
        if (this.gridExpand) await this.expandGrid();
        this.focusOnEditableCell(
          this.validationDataField,
          this.validationLineKey
        );
        this.validationLineKey = undefined;
      }
    },
    dataSourceProductEntry: {
      handler(val) {
        this.setFooterItems(val._array);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    // ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),
    getScreenJson() {
      return {
        title: "Stock Adjustment",
      };
    },
    /**
     * Return header toolbar config
     */
    getHeaderToolbar() {
      return {
        audit: this.baseView.mode === "review",
        status: true,
        notes: false,
        editURL: `/${this.getScreenRowClickNavigation(
          "StockTransferVersionInUse",
          "stock-transfer"
        )}`,
        editCallBack: () => {
          this.dataSourceProductEntry.clear();

          setTimeout(() => {
            this.refreshView();
            this.showLoading(true);
            this.initialized();
          }, 100);
        },
        save: this.model.Status !== "C" && this.model.Status !== "X",
        saveOptions: {
          items: this.baseView.id
            ? [
                { text: "Save Pending", id: "P" },
                { text: "Save & Commit", id: "C", default: true },
                { text: "Cancel", id: "X" },
              ]
            : [
                { text: "Save Pending", id: "P" },
                { text: "Save & Commit", id: "C", default: true },
              ],
          keyExpr: "id",
          displayExpr: "text",
          dropDownOptions: {
            width: "150px",
          },
          saveKey: "NextStatus",
        },

        // saveCallback: this.saveStockTransfer,
        screenName: "Stock Transfers - All",
        pdf: this.baseView.mode === "review",

        toolbarFormItems: [
          {
            dataField: "DateIn",
            editorType: "dxDateBox",
            label: {
              text: "Date",
            },
            editorOptions: {
              displayFormat: "dd MMM yyyy",
              width: 120,
              min: this.minDate,
              max: this.ui.DateAdjustedMax,
              readOnly: this.baseView.mode === "review",
              tabIndex: 1,
              onFocusIn: (e) => {
                e.event.target.select();
              },
            },
            // validationRules: [
            //   {
            //     type: "required",
            //     message: "Date Received is required",
            //   },
            // ],
          },
          // },
        ],
        formContentReady: (e) => {
          if (e && this.baseView.mode !== "review" && this.loaded)
            setTimeout(() => {
              var headerToolBarForm = e.component;
              if (headerToolBarForm && headerToolBarForm.getEditor("DateIn"))
                headerToolBarForm.getEditor("DateIn").instance().focus();
            }, 500);
        },
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
        ellipsis: {
          visible: this.baseView.mode === "review",
          menuItems: this.ellipsisMenu,
          clickAction: (e) => {
            if (e.itemData.menuText === "Cancel") {
              this.onCancelClickHandle();
            } else if (e.itemData.menuText === "Copy") {
              this.onCopyClickHandle();
            }
          },
        },
      };
    },
    /**
     * Return main header form items
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Branch",
                  label: {
                    text: "From Branch",
                  },
                  dataField: "BranchCode",
                  required: true,
                  editorOptions: {
                    onValueChanged: this.onFromBranchValueChanged.bind(this),
                    onSelectionChanged: this.onBranchSelectionChanged,
                    tabIndex: 2,
                  },
                  dataSourceConfig: {
                    data: this.branchDataSourceItems,
                  },
                },
                {
                  screenField: "ConNote",
                  dataField: "ConsignmentNo",
                  label: {
                    text: "Consignment",
                  },
                  editorOptions: {
                    maxLength: 10,
                    tabIndex: 3,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Branch",
                  label: {
                    text: "To Branch",
                  },
                  dataField: "ToBranchCode",
                  required: true,
                  editorOptions: {
                    tabIndex: 4,
                    // onItemClick: this.onToBranchValueChanged.bind(this),
                    onItemClick: () => {
                      this.goToCommentForm("DeliveryInstruction1");
                    },
                  },
                  dataSourceConfig: {
                    data: this.branchDataSourceItems.filter(
                      (x) => x.Code !== this.model.BranchCode
                    ),
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    /**
     * Return header comments form items
     */
    getCommentsFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "DeliveryInstruction1",
              label: { text: "Delivery 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 5,
              },
            },
            {
              dataField: "DeliveryInstruction2",
              label: { text: "Delivery 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 6,
              },
            },
            {
              dataField: "Comment1",
              label: { text: "Comment 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 7,
              },
            },
            {
              dataField: "Comment2",
              label: { text: "Comment 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 8,
              },
            },
            {
              dataField: "Comment3",
              label: { text: "Comment 3" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 9,
              },
            },
            {
              dataField: "Comment4",
              label: { text: "Comment 4" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 10,
              },
            },
            {
              dataField: "Comment5",
              label: { text: "Comment 5" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 11,
                // onKeyDown: this.onComment5KeyDown,
                onKeyDown: (e) => {
                  if (forwardTabbing(e)) {
                    e.event.preventDefault();
                    const dataGrid = this.dataGrid;
                    const i = this.dataSourceProductEntry._array.findIndex(
                      (x) => !x.ProductCode
                    );
                    if (i !== -1) {
                      let rowIndex = 0;
                      // dataGrid.getRowIndexByKey(
                      //   this.dataSourceProductEntry._array[i].ID
                      // );
                      const cellElement = dataGrid.getCellElement(
                        rowIndex,
                        "ProductCode"
                      );
                      dataGrid.focus(cellElement);
                      dataGrid.editCell(rowIndex, "ProductCode");
                    }
                  }
                },
              },
            },
          ],
        },
      ];
    },
    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 6 : this.headerFormHeight) - 95
        );
      else return this.gridHeight - 95;

      // -95 => Space for footer
    },
    getColumns() {
      return [
        {
          caption: "Product",
          dataField: "ProductCode",
          fixed: true,
          fixedPosition: "left",
          // width: "auto",
          width: ColumnWidth.PurchaseOrderCode.width,
          minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: StockTransferService.dataSourceConfig("api/Product", {
              filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
              select: [
                "Code",
                "Description1",
                "Inactive",
                "IsBatchProduct",
                "UnitOfMeasureCode",
                "StockEnquiryQuantities",
                "BestBeforeShelfLife",
                "UseByShelfLife",
              ],
              expand:
                "StockEnquiryQuantities($select=BranchCode,OnHand,ItemCode)",
              sort: "Code asc",
              // preventPagination: true,
            }),
            searchExpr: ["Code", "Description1"],
            searchTimeout: 10,
            searchEnabled: true,
            // showDataBeforeSearch: false,
            // minSearchLength: 1,
            displayExpr: "Code",
            valueExpr: "Code",
            valueChangeEvent: "focusout",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.Code}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description1}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 400,
            },
            onKeyDown: this.onEnterProductCode,
            onItemClick: (e, lineData) => {
              // this.onEnterProductCode({ event: { key: "Enter" } }, lineData);

              this.dataGrid.byKey(lineData.data.ID).then((res) => {
                if (res.Onhand < 0 || res.IsBatchProduct !== "No")
                  this.focusOnCellByRowIndex(lineData.data, "Comment");
                else this.focusOnCellByRowIndex(lineData.data, "TransferQty");
              });
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
          },
          setCellValue: this.onSetProduct,
        },
        {
          caption: "Description",
          dataField: "ProductDescription1",
          allowEditing: false,
          allowSorting: this.baseView.mode === "review",
          minWidth: 250,
        },
        {
          caption: "UM",
          dataField: "UnitOfMeasureCode",
          allowSorting: this.baseView.mode === "review",
          allowEditing: false,
          allowFiltering: false,
          width: 80,
        },
        {
          caption: "On Hand",
          dataField: "Onhand",
          allowSorting: this.baseView.mode === "review",
          allowFiltering: false,
          format: "##,###,###,###,##0.0000",
          width: 150,
          allowEditing: false,
          cellTemplate: "Decimal",
          visible: this.baseView.mode !== "review",
        },
        {
          caption: `Transfer`,
          dataField: "TransferQty",
          dataType: "number",
          format: "##,###,###,###,##0.0000",
          allowSorting: this.baseView.mode === "review",
          allowFiltering: false,
          width: 160,
          cssClass: "edit-cell-numberbox-field",
          allowEditing: this.baseView.mode !== "review",
          editorOptions: {
            format: "###,###,##0.0000",
            max: 999999999.0,
            // min: 0,
            step: 0,
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onInput: (e) => {
              const inputElement = e.event.target;
              if (inputElement.value.length > 16)
                inputElement.value = inputElement.value.slice(0, 16);
            },
            onKeyDown: (e, lineData) => {
              setTimeout(() => {
                this.moveOnEnterKey(e, lineData);
              }, 150);
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (value < 0) {
              await this.$alert(
                `${
                  currentRowData.ProductDescription1
                } has a Transfer quantity of ${formatNumber(
                  value,
                  "##,###,###,###,##0.0000"
                )}, which is less than the 0. Please update your Transfer quantity so that is less than or equal to ${formatNumber(
                  currentRowData.Onhand,
                  "##,###,###,###,##0.0000"
                )}`,
                "Warning"
              );
              newData.TransferQty = currentRowData.TransferQty;
              setTimeout(() => {
                this.focusOnCellByRowIndex(currentRowData, "TransferQty");
              }, 50);
            } else if (value > currentRowData.Onhand) {
              await this.$alert(
                `${
                  currentRowData.ProductDescription1
                } has a Transfer quantity of ${formatNumber(
                  value,
                  "##,###,###,###,##0.0000"
                )}, which is greater  than the On Hand quantity of ${formatNumber(
                  currentRowData.Onhand,
                  "##,###,###,###,##0.0000"
                )}
                in Branch ${
                  this.model.BranchCode + ` - ` + this.model.BranchDescription
                }. Please update your Transfer quantity so that is less than or equal to ${formatNumber(
                  currentRowData.Onhand,
                  "##,###,###,###,##0.0000"
                )}`,
                "Warning"
              );
              newData.TransferQty = currentRowData.TransferQty;
              setTimeout(() => {
                this.focusOnCellByRowIndex(currentRowData, "TransferQty");
              }, 50);
            } else newData.TransferQty = value;

            return newData;
          },
        },
        {
          caption: "Comments",
          dataField: "Comment",
          allowSorting: this.baseView.mode === "review",
          minWidth: 220,
          allowEditing: this.baseView.mode !== "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            onKeyDown: this.moveOnEnterKey,
            maxLength: 1000,
          },
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          width: 60,
          minWidth: 30,
          buttons: [
            {
              name: "add",
              icon: "add",
              onClick: (e) => {
                this.addNewRowByPosition(e, "add-line");
              },
            },
            // {
            //   name: "copy",
            //   icon: "copy",
            //   onClick: (e) => {
            //     this.addNewRowByPosition(e, "copy-line");
            //   },
            // },
            {
              name: "delete",
            },
          ],
          visible: this.baseView.mode !== "review",
        },
      ];
    },
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return "/stock-transfer";
    },
    dataGrid() {
      return this.$refs["dx-data-grid-comp"].instance;
    },
    /**
     * Return Defined Columns for Product search model
     */
    getProductSearchColumns() {
      return [
        {
          screenField: "Comments",
          label: "Product",
          dataField: "Code",
        },
        {
          screenField: "Comments",
          label: "Description",
          dataField: "Description1",
        },
      ];
    },
    /**
     * Return data source for Product search model
     */
    getProductSearchDataSource() {
      return ProductService.dataSourceConfig(
        "api/Product?&$expand=StockEnquiryQuantities",
        {
          filter: [["Status", "=", "A"], "and", ["Inactive", "=", "N"]],
          // key: ["ItemCode", "BranchCode"],
        }
      );
    },
    // Footer
    /**
     * Footer Left Item
     * @returns {(*|{[p: string]: *})[]}
     */
    footerLeftItems() {
      return getFooterLeftItems(this.footerItems, this.model);
    },
    /**
     * Footer Right Item
     * @returns {(*|{[p: string]: *})[]}
     */
    footerRightItems() {
      return getFooterRightItems(this.footerItems, this.model);
    },
    /**
     * Footer Item
     * @returns {[{dataField: string, screenField: string, customCalc: (function(*, *): number), location: string, label: string, value: number},{dataField: string, screenField: string, location: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number}]}
     */
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SupplierRequired",
          location: "left",
          label: "Line Count",
          value: 0,
          customCalc: (headerData, gridItems) => {
            let count = 0;
            gridItems.forEach((element) => {
              if (element.ProductCode) count++;
            });

            return count;
          },
        },
        {
          screenField: "SalesUMItemCount",
          dataField: "TransferQty",
          location: "left",
          value: 0,
        },
      ];
    },
    getLabel() {
      return !this.expandChildGrid ? "Collapse" : "Expand";
    },
  },
  beforeCreate() {
    this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  },
  methods: {
    onRowPrepared(e) {
      if (e.rowType === "data") {
        if (!e.data.IsValid && this.baseView.mode !== "review") {
          e.rowElement.classList.add("alert-row");
          if (e.rowElement.classList.contains("dx-row-alt")) {
            e.rowElement.classList.add("dx-row-alt-back");
            e.rowElement.classList.remove("dx-row-alt");
          }
        } else {
          e.rowElement.classList.remove("alert-row");
          if (e.rowElement.classList.contains("dx-row-alt-back")) {
            e.rowElement.classList.remove("dx-row-alt-back");
            e.rowElement.classList.add("dx-row-alt");
          }
        }
      }
    },
    /**
     *
     * @param id
     * @returns {*}
     */
    getMasterDataInstance(id) {
      return this.$refs["master-details-" + id].instance;
    },
    /**
     *
     */
    onAddNewBatchLine(e) {
      if (e.event) {
        let data = e.row.data;
        if (!data.BatchNo) {
          this.$alert("Batch No is required", "Validation Error");
        } else if (
          data.IsManufacturedDateRequired === "Y" &&
          !data.ManufacturedDate
        ) {
          this.$alert("Manufactured Date is required", "Validation Error");
        } else {
          let instance = this.getDataGridInstance();
          instance.byKey(data.ParentID).then((lineParent) => {
            this.addNewBatchLine(lineParent);
          });
        }
      }
    },
    async onBatchNoKeyDown(e, cellInfo) {
      if (e.event) {
        let batchGridInstance = cellInfo.component;
        if (backwardTabbing(e)) {
          if (cellInfo.data.rowIndex === 0) {
            if (batchGridInstance) this.BatchGridInstance = batchGridInstance;
            batchGridInstance.option("focusedRowIndex", -1);
            e.event.preventDefault();
            let data = cellInfo.data.data;
            let instance = this.getDataGridInstance();
            let parentRowIndex = instance.getRowIndexByKey(data.ParentID);

            this.focusOnEditableCell(parentRowIndex, "Comment");
          }
        } else if (forwardTabbing(e)) {
          this.batchNoTabKey = true;
          let item = cellInfo.data.data;
          let rowIndex = batchGridInstance.getRowIndexByKey(item.BatchLineNo);

          if (cellInfo.data.data.FromBatchDB) {
            e.event.preventDefault();
            if (batchGridInstance) {
              let cellElement = batchGridInstance.getCellElement(
                0,
                "TransferQty"
              );

              if (cellElement) {
                batchGridInstance.focus(cellElement);
                setTimeout(() => {
                  batchGridInstance.editCell(rowIndex, "TransferQty");
                }, 1);
              }
            }
          } else {
            // await this.$alert("Batch is required", "Warning");
            // setTimeout(() => this.focusOnBatchEditableCell(rowIndex), 200);
          }
        }
      }
    },
    // focusOnEditingCell(rowIndex, dataField) {
    //   setTimeout(() => {
    //     let gridInstance = this.getDataGridInstance();
    //     if (gridInstance) {
    //       let cellElement = gridInstance.getCellElement(rowIndex, dataField);
    //       if (cellElement) {
    //         gridInstance.focus(cellElement);
    //         setTimeout(() => {
    //           gridInstance.editCell(rowIndex, dataField);
    //         }, 1);
    //       }
    //     }
    //   }, 10);
    // },
    getDataGridInstance() {
      return this.$refs["dx-data-grid-comp"].instance;
    },
    async onSetProduct(newData, value, currentRowData) {
      let include = this.dataSourceProductEntry._array.findIndex(
        (x) => x.ProductCode === value
      );
      if (include !== -1) {
        await this.$alert(
          `${this.dataSourceProductEntry._array[include].ProductDescription1} has already been added to this Stock Transfer. Please update the existing line`,
          "Warning"
        );
        newData.ProductCode = currentRowData.ProductCode;
        setTimeout(() => {
          this.focusOnCellByRowIndex(currentRowData, "ProductCode");
        }, 50);
      } else {
        newData.ProductCode = value;

        let index = -1;

        if (!this.selectedProduct)
          index = this.productDataSourceItems.findIndex(
            (x) => x.Code === value
          );

        if (index !== -1 || this.selectedProduct) {
          const data = this.selectedProduct
            ? this.selectedProduct
            : this.productDataSourceItems[index];

          this.setRowProduct(newData, data, currentRowData);
        }

        if (!currentRowData.ProductCode && currentRowData.IsNewLine !== true)
          this.addNewRow(false);

        this.dataSourceProductEntry.update(currentRowData.ID, newData);

        if (this.dataGrid) {
          let rowIndex = this.dataGrid.getRowIndexByKey(currentRowData.ID);
          if (rowIndex !== -1) {
            setTimeout(() => {
              this.$nextTick(() => {
                this.dataGrid.repaintRows([rowIndex]);
                if (newData.IsBatchProduct !== "No") {
                  this.getDataGridInstance().expandRow(currentRowData.ID);
                } else {
                  this.getDataGridInstance().collapseRow(currentRowData.ID);
                }
              });
            }, 50);
          }
        }

        return newData;
      }
    },
    setRowProduct(newData, data, currentRowData, isNew = true) {
      newData.ProductDescription1 = data.Description1;
      newData.UnitOfMeasureCode = data.UnitOfMeasureCode;
      newData.StockEnquiryQuantities = data.StockEnquiryQuantities;
      newData.IsBatchProduct = data.IsBatchProduct;
      newData.BestBeforeShelfLife = data.BestBeforeShelfLife;
      newData.UseByShelfLife = data.UseByShelfLife;

      data.StockEnquiryQuantities.forEach((stockItem) => {
        if (stockItem.BranchCode === this.model.BranchCode) {
          newData.Onhand = stockItem.OnHand;
        }
      });

      if (typeof newData.TransferQty !== "undefined") {
        newData.IsValid = newData.Onhand > newData.TransferQty;
      } else {
        newData.TransferQty = 0;
      }

      if (newData["IsBatchProduct"] !== "No" && isNew) {
        newData["IsVisibleBatchData"] = true;
        newData["ChildDataSource"] = new ArrayStore({
          key: "BatchLineNo",
          data: [],
        });

        const batchItem = Object.assign({ ...batchItemBase });
        batchItem.ParentID = currentRowData.ID;
        batchItem.IsValid = true;
        newData.ChildDataSource.insert(batchItem);
      }
      return newData;
    },
    addNewBatchLine(lineParent, focusByDefault = true) {
      let maxLineNo = Math.max(
        ...lineParent.ChildDataSource._array.map((e) => e.BatchLineNo)
      );
      if (lineParent.ChildDataSource._array.length === 0)
        maxLineNo = parseInt(lineParent.ID.toString() + "0") * 100;
      const batchItem = { ...batchItemBase };
      batchItem.ParentID = lineParent.ID;
      batchItem.BatchLineNo = ++maxLineNo;
      lineParent.ChildDataSource.insert(batchItem);

      this.dataSourceProductEntry.update(lineParent.ID, lineParent);
      this.BatchGridInstance = this.getMasterDataInstance(lineParent.ID);
      setTimeout(() => {
        this.BatchGridInstance.saveEditData();
        this.BatchGridInstance.refresh(true);
        setTimeout(() => {
          const rowIndex = this.BatchGridInstance.getRowIndexByKey(
            batchItem.BatchLineNo
          );
          if (rowIndex !== -1 && focusByDefault) {
            this.focusOnBatchEditableCell(rowIndex);
          }
        }, 50);
      }, 250);
    },
    focusOnBatchEditableCell(rowIndex, col) {
      const column = col ? col : "BatchNo";
      const batchDataGrid = this.BatchGridInstance;

      const cellElement = batchDataGrid.getCellElement(rowIndex, column);
      batchDataGrid.focus(cellElement);
      setTimeout(() => {
        batchDataGrid.editCell(rowIndex, column);
      }, 10);
    },
    getChildGridColumns(data) {
      const viewportWidth = window.innerWidth;
      let additionalSize = 0;
      if (viewportWidth >= 1698) {
        additionalSize = 204;
      }
      let item = data.data;

      let visibleUseBy = true;
      let visibleBestBefore = true;
      // let changeWidth = 0;

      if (item.UseByShelfLife === -1 && item.BestBeforeShelfLife === -1) {
        visibleUseBy = false;
        visibleBestBefore = false;
        // changeWidth = ColumnWidth.Date.width / 2;
      } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
        visibleBestBefore = false;
      } else if (
        item.UseByShelfLife > -1
        // && item.BestBeforeShelfLife != -1
      ) {
        visibleBestBefore = false;
      } else if (
        item.BestBeforeShelfLife > -1
        // && item.UseByShelfLife != -1
      ) {
        visibleUseBy = false;
      }

      return this.parseColumnWithScreenFields([
        {
          screenField: "Batch",
          dataField: "BatchNo",
          allowEditing: item.IsBatchProduct !== "No",
          showEditorAlways: false,
          width: ColumnWidth.BatchNo.width - 20,
          minWidth: ColumnWidth.BatchNo.minWidth - 20,
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig(
              "api/ConsumeProductBatch",
              {
                filter: [
                  ["ItemCode", "=", item.ProductCode],
                  ["BranchCode", "=", this.model.BranchCode],
                  ["SourceTransactionType", "=", ""],
                  ["SourceTransactionNo", "=", 0],
                  ["SourceTransactionLine", "=", 0],
                  ["SourceTransactionProcessCode", "=", ""],
                ],
                // select: [
                //   "BatchNo",
                //   "BranchCode",
                //   "SupplierCode",
                //   "SupplierBatchNo",
                //   "ManufacturedDate",
                //   "UseByDate",
                //   "BestBeforeDate",
                //   "AvailableQty",
                //   "AllocatedQty",
                //   "OnHand",
                // ],
                sort: "UseByDateForSort asc,BestBeforeDateForSort asc,DateCreated asc",
              }
            ),
            displayExpr: "BatchNo",
            valueExpr: "BatchNo",
            searchTimeout: 10,
            searchEnabled: true,
            itemTemplate: (data) => {
              let secondary = data.SupplierBatchNo;
              if (data.UseByDate) secondary += " | " + data.UseByDate;
              else {
                if (data.BestBeforeDate)
                  secondary += " | " + data.BestBeforeDate;
              }
              secondary += " | " + data.AvailableQty.roundNumber(4);

              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.BatchNo}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${secondary}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 400,
            },
            // acceptCustomValue: true,
            // onCustomItemCreating: this.onCustomItemCreating, // user can not create new batch line ins stock transfer
            onSelectionChanged: (e) => (this.selectedBatch = e.selectedItem),
            onKeyDown: this.onBatchNoKeyDown,
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          setCellValue: this.onBatchSet,
        },
        {
          screenField: "SupplierBatchNo",
          cssClass: "edit-cell-textbox-field",
          allowEditing: false,
          width:
            ColumnWidth.SupplierBatchNo.width +
            (this.baseView.mode !== "review"
              ? 225 + additionalSize
              : 527 + additionalSize),
          minWidth:
            ColumnWidth.SupplierBatchNo.minWidth +
            (this.baseView.mode !== "review" ? 225 + additionalSize : 349),
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // onKeyDown: this.onSupplierBatchNoKeyDown,
          },
        },
        {
          caption: "On Hand",
          dataField: "OnHand",
          allowEditing: false,
          type: Number,
          format: "##,###,###,###,##0.0000",
          width: ColumnWidth.Quantity2DecimalPoints.width + 4,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          cssClass: "decimal-cell",
          visible: this.baseView.mode !== "review",
        },
        {
          caption: "Allocated",
          dataField: "AllocatedQty",
          allowEditing: false,
          cssClass: "edit-cell-numberbox-field",
          format: "##,###,###,###,##0.0000",
          editorOptions: {
            // onFocusIn: (e) => {
            //   e.event.target.select();
            //   this.clearBatchGridSelection();
            // },
            // onKeyDown: (e, lineData) => {
            //   console.log(lineData)
            // },
            format: "##,###,###,###,##0.0000",
            max: 999999999.0,
            step: 0,
          },
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          visible: this.baseView.mode !== "review",
        },
        {
          caption: "Available",
          dataField: "AvailableQty",
          allowEditing: false,
          type: Number,
          format: "##,###,###,###,##0.0000",
          width: ColumnWidth.Quantity2DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          cssClass: "decimal-cell",
          visible: this.baseView.mode !== "review",
        },
        {
          caption: "Transfer",
          dataField: "Transfer",
          allowEditing: this.baseView.mode !== "review",
          cssClass: "edit-cell-numberbox-field",
          format: "##,###,###,###,##0.0000",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // },
            format: "##,###,###,###,##0.0000",
            max: 999999999.0,
            step: 0,
          },
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          setCellValue: this.onTransferQtyHandler,
          visible: true,
        },
        {
          screenField: "DateIn",
          caption: "Manufactured Date",
          dataField: "ManufacturedDate",
          allowEditing: false,
          allowSearch: false,
          dataType: "date",
          editable: true,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          format: "dd MMM yyyy",
          showEditorAlways: false,
          cssClass: "edit-cell-datebox-field-border",
          editorOptions: {
            format: "dd MMM yyyy",
            // onKeyDown: this.onManufacturedDateKeyDown,
          },
        },
        {
          screenField: "UseByDate",
          allowEditing: false,
          allowSearch: false,
          showEditorAlways: false,
          cssClass: "edit-cell-datebox-field-border",
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleUseBy,
          format: "dd MMM yyyy",
          editorOptions: {
            format: "dd MMM yyyy",
            // onKeyDown: this.onUseByDateKeyDown,
          },
        },
        {
          screenField: "BestBeforeDate",
          allowEditing: false,
          allowSearch: false,
          showEditorAlways: false,
          cssClass: "edit-cell-datebox-field-border",
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleBestBefore,
          format: "dd MMM yyyy",
          editorOptions: {
            format: "dd MMM yyyy",
            // onKeyDown: this.onUseByDateKeyDown, // UseByDate & BestBeforeDate Both acts in the same way
          },
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          width: 110,
          buttons: [
            {
              hint: "Add Batch Line",
              icon: "add",
              visible: true,
              onClick: this.onAddNewBatchLine.bind(this),
            },
            "delete",
          ],
          visible: this.baseView.mode !== "review",
        },
      ]);
    },
    /**
     *
     * @param id
     */
    updateParent(id) {
      const currentData = this.dataSourceProductEntry._array.find(
        (item) => item.ID === id
      );

      if (currentData) {
        const totals = currentData.ChildDataSource._array.reduce(
          (calc, item) => {
            return {
              Transfer: calc.Transfer + item.Transfer,
            };
          },
          {
            Transfer: 0,
          }
        );

        currentData.TransferQty = totals.Transfer.roundNumber(4);
        if (currentData) {
          const dataGrid = this.getDataGridInstance();
          const index = dataGrid.getRowIndexByKey(id);
          dataGrid.repaintRows([index]);
        }
      }
    },
    async onTransferQtyHandler(newData, value, currentRowData) {
      const index = this.BatchGridInstance.getRowIndexByKey(
        currentRowData.BatchLineNo
      );
      if (value < 0) {
        await this.$alert(
          `${
            currentRowData.ProductDescription1
          } has a Transfer quantity of ${formatNumber(
            value,
            "##,###,###,###,##0.0000"
          )}, which is less than the 0. Please update your Transfer quantity so that is less than or equal to ${formatNumber(
            currentRowData.OnHand,
            "##,###,###,###,##0.0000"
          )}`,
          "Warning"
        );
        newData.Transfer = currentRowData.Transfer;
        setTimeout(() => {
          this.focusOnBatchEditableCell(index, "Transfer");
        }, 100);
      } else if (value > currentRowData.AvailableQty) {
        await this.$alert(
          `${currentRowData.BatchNo} for ${currentRowData.ProductCode} - ${
            currentRowData.ProductDescription1
          } has a Transfer quantity of ${formatNumber(
            value,
            "##,###,###,###,##0.0000"
          )}, which is greater that than the Available quantity of ${formatNumber(
            currentRowData.AvailableQty,
            "##,###,###,###,##0.0000"
          )} in Branch ${
            this.model.BranchCode + ` - ` + this.model.BranchDescription
          }. \nPlease update your Transfer quantity so that is less than or equal to ${formatNumber(
            currentRowData.AvailableQty,
            "##,###,###,###,##0.0000"
          )}`,
          "Warning"
        );
        newData.Transfer = currentRowData.Transfer;
        setTimeout(() => {
          this.focusOnBatchEditableCell(index, "Transfer");
        }, 100);
      } else {
        newData.Transfer = value;
        setTimeout(() => this.updateParent(currentRowData.ParentID), 200);
        if (this.tabKey) {
          this.tabKey = false;
          this.goToNextRow(currentRowData);
        }
        // const nextIndex = this.getNextIndex(this.getDataGridInstance(), this.dataSourceProductEntry._array, "ID", currentRowData.ParentID)
        // this.focusOnEditableCell(nextIndex, "ProductCode");
      }

      return newData;
    },
    onCustomItemCreating(e) {
      e.customItem = {
        BatchNo: e.text,
      };
    },
    goToNextRow(currentRowData) {
      const currentProduct = this.dataSourceProductEntry._array.find(
        (product) => product.ID === currentRowData.ParentID
      );
      if (currentProduct) {
        const batchIndex = currentProduct.ChildDataSource._array.findIndex(
          (batch) => batch.BatchLineNo === currentRowData.BatchLineNo
        );
        if (batchIndex !== -1) {
          const nextBatch =
            currentProduct.ChildDataSource._array[batchIndex + 1];
          if (nextBatch) {
            const nextIndex = this.BatchGridInstance.getRowIndexByKey(
              nextBatch.BatchLineNo
            );
            this.focusOnBatchEditableCell(nextIndex, "BatchNo");
          } else {
            const dataGrid = this.dataGrid;
            if (dataGrid) {
              let nextIndex = dataGrid.getRowIndexByKey(
                currentRowData.ParentID
              );
              nextIndex = nextIndex + 2;
              this.focusOnEditableCell(nextIndex, "ProductCode");
            }
          }
        }
      }
    },
    getNextIndex(instance, arrayData, idKey, currentID) {
      const currentIndex = arrayData.findIndex(
        (item) => item[idKey] === currentID
      );
      if (currentIndex !== -1) {
        const nextData = arrayData[currentIndex + 1];
        if (nextData) {
          return instance.getRowIndexByKey(nextData[idKey]);
        }
      }
    },
    /**
     *
     * @param type
     * @param dataObj
     * @returns {Promise<void>}
     */
    async updateLocalDataSet(type, dataObj) {
      if (type === "insert") {
        if (
          this.dataSourceProductEntry._array.length !== 0 &&
          this.dataSourceProductEntry._array[
            this.dataSourceProductEntry._array.length - 1
          ].Code
        ) {
          this.dataSourceProductEntry.insert(dataObj);
        } else if (this.dataSourceProductEntry._array.length === 0) {
          this.dataSourceProductEntry.insert(dataObj);
        }
      } else if (type === "update") {
        this.dataSourceProductEntry.update(dataObj.ID, dataObj);
      }
      this.dataGrid.saveEditData();
    },
    async getConsumeProductBatch(code, batchNo, branchCode = "") {
      const branchFilter =
        branchCode === "" ? `` : `BranchCode eq '${branchCode}' and `;
      return ProductService.getCustomData({
        url: "api/ConsumeProductBatch",
        filter: `${branchFilter}ItemCode eq '${code}' and SourceTransactionType eq '' and SourceTransactionNo eq 0 and SourceTransactionLine eq 0 and SourceTransactionProcessCode eq '' and BatchNo eq '${batchNo}'`,
        // select: "BatchNo,BranchCode,SupplierCode,SupplierBatchNo,ManufacturedDate,UseByDate,BestBeforeDate,AvailableQty,AllocatedQty,OnHand",
        top: 1,
      });
    },
    /**
     *
     * @param newData
     * @param value
     * @param currentRowData
     * @returns {Promise<*>}
     */
    async onBatchSet(newData, value, currentRowData) {
      const currentProduct = this.dataSourceProductEntry._array.find(
        (product) => product.ID === currentRowData.ParentID
      );
      if (currentProduct) {
        const currentBatch = currentProduct.ChildDataSource._array.find(
          (batch) => batch.BatchNo === value
        );
        if (currentBatch) {
          await this.$alert(
            `${value} has already been added to this Batch in Current Product. Please update the existing line`,
            "Warning"
          );
          return false;
        }
      }
      let branchCode = "";
      let productCode = "";
      if (currentProduct) {
        branchCode = currentProduct.BranchCode;
        productCode = currentProduct.ProductCode;
      }
      const batchItems = await this.getConsumeProductBatch(
        productCode,
        value,
        branchCode
      );

      newData.BatchNo = value;
      this.setBatch(newData, batchItems, currentProduct);
      let dataField = undefined;
      if (newData.FromBatchDB) {
        dataField = "Transfer";
        if (dataField && this.BatchGridInstance) {
          let rowIndex = this.BatchGridInstance.getRowIndexByKey(
            currentRowData.BatchLineNo
          );
          let cellElement = this.BatchGridInstance.getCellElement(
            rowIndex,
            dataField
          );
          if (cellElement) {
            this.BatchGridInstance.focus(cellElement);
            setTimeout(() => {
              this.BatchGridInstance.editCell(rowIndex, dataField);
            }, 50);
          }
        }
      }
      // setTimeout(() => this.updateParent(item.ID), 100);
      if (this.isLastBatchRow(currentRowData)) {
        this.addNewBatchLine(currentProduct, false);
      }
      return newData;
    },

    /**
     * check and return if the current row is the last row of batch grid or not
     * @param currentRowData
     */
    isLastBatchRow(currentRowData) {
      let rowIndex = this.BatchGridInstance.getRowIndexByKey(
        currentRowData.BatchLineNo
      );

      let totalRow = this.BatchGridInstance.getDataSource().totalCount();

      if (rowIndex === totalRow - 1) return true;
      else return false;
    },
    setBatch(newData, batchItems, item) {
      if (batchItems.data.value.length > 0) {
        let data = batchItems.data.value[0];
        if (data) {
          newData.ParentID = item.ID;
          newData.OnHand = data.OnHand.roundNumber(4);
          newData.ProductDescription1 = item.ProductDescription1;
          newData.ProductCode = item.ProductCode;
          newData.SupplierBatchNo = data.SupplierBatchNo;
          newData.SupplierCode = data.SupplierCode;
          newData.AvailableQty = data.AvailableQty;
          newData.AllocatedQty = data.AllocatedQty;
          if (data.ManufacturedDate)
            newData.ManufacturedDate = new Date(data.ManufacturedDate);
          if (data.BestBeforeDate)
            newData.BestBeforeDate = new Date(data.BestBeforeDate);
          if (data.UseByDate) newData.UseByDate = new Date(data.UseByDate);

          newData.FromBatchDB = true;
        } else {
          newData.FromBatchDB = false;
        }
      } else {
        newData.FromBatchDB = false;
      }
    },
    onBatchEditingStart() {
      // let data = e.data;
      // if (
      //     e.column.dataField === "ManufacturedDate" ||
      //     e.column.dataField === "SupplierBatchNo"
      // ) {
      //   if (data.FromBatchDB) {
      //     e.cancel = true;
      //   }
      // }
      //
      // if (
      //     e.column.dataField === "UseByDate" ||
      //     e.column.dataField === "BestBeforeDate"
      // ) {
      //   if (!data.ManufacturedDate || data.FromBatchDB) {
      //     e.cancel = true;
      //   }
      // }
    },
    /**
     *
     * @param e
     */
    onBatchCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "BatchNo") {
          if (e.data.IsBatchProduct !== "No" && !e.data.BatchNo) {
            e.cellElement.classList.add("gc-require-validation");
          }
        }
      }
    },
    /**
     *
     * @param e
     */
    onBatchFocusedCellChanged(e) {
      let gridInstance = this.getDataGridInstance();
      if (gridInstance) gridInstance.option("focusedRowIndex", -1);

      if (e) {
        this.BatchGridInstance = e.component;
      }
    },
    /**
     *
     * @param e
     */
    onBatchEditorPreparing(e) {
      if (e.dataField && e.dataField === "BatchNo") {
        e.editorName = "dxSelectBox";
      }
      const disEditList = [
        // "ManufacturedDate",
        "SupplierBatchNo",
        // "UseByDate",
        // "BestBeforeDate",
      ];
      if (e.row.data.FromBatchDB) {
        disEditList.map((disItem) => {
          const el = e.row.cells.find(
            (item) => item.column.dataField === disItem
          );
          if (el) {
            el.column.allowEditing = false;
          }
        });
      }
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode !== "review" && e.parentType !== "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            if (forwardTabbing(event) || onEnter(event)) {
              new Promise(() =>
                setTimeout(() => {
                  this.goToBatchNextEditableComponent(e.row, e.name);
                }, 150)
              );
            } else if (backwardTabbing(event)) {
              event.event.preventDefault();
              this.goToBatchPrevEditableComponent(e.row, e.name);
            }
            func(event, {
              data: e.row,
              component: e.component,
              index: e.index,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    /**
     *
     * @param row
     * @param name
     */
    goToBatchPrevEditableComponent(row, name) {
      const column = row.cells.find((item) => item.column.dataField === name);
      const element = row.cells
        .reverse()
        .find(
          (item) =>
            item.columnIndex < column.columnIndex &&
            item.column.allowEditing &&
            !item.column.readOnly
        );
      row.cells.reverse();
      if (element) {
        let instance = this.BatchGridInstance;
        instance.focus(element.cellElement);
        instance.editCell(row.rowIndex, element.columnIndex);
      } else {
        const currentProduct = this.dataSourceProductEntry._array.find(
          (product) => product.ID === row.data.ParentID
        );
        if (currentProduct) {
          const batchIndex = currentProduct.ChildDataSource._array.findIndex(
            (batch) => batch.BatchLineNo === row.data.BatchLineNo
          );
          if (batchIndex !== -1) {
            const nextBatch =
              currentProduct.ChildDataSource._array[batchIndex - 1];
            if (nextBatch) {
              const nextIndex = this.BatchGridInstance.getRowIndexByKey(
                nextBatch.BatchLineNo
              );
              this.focusOnBatchEditableCell(nextIndex, "Transfer");
            } else {
              const dataGrid = this.dataGrid;
              const parentRowIndex = dataGrid.getRowIndexByKey(
                row.data.ParentID
              );
              this.focusOnEditableCell(parentRowIndex, "Comment");
            }
          }
        }
        // if (component) this.BatchGridInstance = component;
        // // component.option("focusedRowIndex", -1);
        //
        // const dataGrid = this.dataGrid;
        // const parentRowIndex = dataGrid.getRowIndexByKey(row.data.ParentID);
        // this.focusOnEditableCell(parentRowIndex, "Comment");
      }
    },
    /**
     *
     * @param row
     * @param name
     */
    goToBatchNextEditableComponent(row, name) {
      const column = row.cells.find((item) => item.column.dataField === name);
      const element = row.cells.find(
        (item) =>
          item.columnIndex > column.columnIndex &&
          item.column.allowEditing &&
          !item.column.readOnly
      );
      if (element) {
        this.focusOnBatchEditableCell(row.rowIndex, element.column.name);
      } else {
        this.tabKey = true;
        setTimeout(() => this.goToNextRow(row.data), 50);
      }
    },
    /**
     *
     * @param row
     * @param name
     */
    goToPrevEditableComponent(row, name) {
      const column = row.cells.find((item) => item.column.dataField === name);
      const element = row.cells
        .reverse()
        .find(
          (item) =>
            item.columnIndex < column.columnIndex &&
            item.column.allowEditing &&
            !item.column.readOnly
        );
      row.cells.reverse();
      if (element) {
        let instance = this.dataGrid;
        instance.focus(element.cellElement);
        instance.editCell(row.rowIndex, element.columnIndex);
      } else {
        if (row.rowIndex === 0) {
          this.goToCommentForm("Comment5");
        } else {
          const prevIndex =
            this.dataSourceProductEntry._array.findIndex(
              (item) => item.ID === row.data.ID
            ) - 1;
          const prevProduct = this.dataSourceProductEntry._array[prevIndex];
          if (prevProduct) {
            if (prevProduct.IsBatchProduct !== "No") {
              this.BatchGridInstance = this.getMasterDataInstance(
                prevProduct.ID
              );
              const latestBatch =
                prevProduct.ChildDataSource._array[
                  prevProduct.ChildDataSource._array.length - 1
                ];
              if (latestBatch) {
                const batchKey = this.BatchGridInstance.getRowIndexByKey(
                  latestBatch.BatchLineNo
                );
                this.focusOnBatchEditableCell(batchKey, "Transfer");
              } else {
                this.focusOnBatchEditableCell(0, "Transfer");
              }
            } else {
              const prevIndex = this.getDataGridInstance().getRowIndexByKey(
                prevProduct.ID
              );
              this.focusOnEditableCell(prevIndex, "Comment");
            }
          }
        }
      }
    },
    /**
     *
     * @param row
     * @param name
     */
    goToNextEditableComponent(row, name) {
      const column = row.cells.find((item) => item.column.dataField === name);
      const elm = row.cells.find(
        (item) =>
          item.columnIndex > column.columnIndex &&
          item.column.allowEditing &&
          !item.column.readOnly
      );
      let instance = this.dataGrid;
      if (instance) {
        if (elm) {
          instance.focus(elm.cellElement);
          instance.editCell(row.rowIndex, elm.columnIndex);
        } else {
          if (row.data.IsBatchProduct === "No") {
            const nextIndex = row.rowIndex + 1;
            this.focusOnEditableCell(nextIndex);
          } else {
            this.BatchGridInstance = this.getMasterDataInstance(row.data.ID);
            this.focusOnBatchEditableCell(0, "BatchNo");
          }
        }
      }
    },
    /**
     *
     * @param Code
     * @returns {Promise<boolean>}
     */
    async showCancelConfirmation(Code) {
      return this.$confirm(
        `Are you sure you want to cancel this Stock Transfer #${Code}? This action cannot be undone.`,
        "Cancel Stock Transfer",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
    },
    async onCancelClickHandle() {
      const confirmLeaving = await this.showCancelConfirmation(
        this.baseView.id
      );
      if (confirmLeaving) {
        this.loaded = true;
        await StockTransferService.cancel(this.baseView.id)
          .then((res) => {
            this.$notify(
              `Cancellation of Stock Transfer #${this.baseView.id} is successful`,
              "success"
            );
            if (res) this.loaded = false;

            if (this.baseView.mode === "edit") {
              this.setIgnoreRouteChangeConfirmation();
              this.$router
                .push({
                  path: `/${this.getScreenRowClickNavigation(
                    "StockTransferVersionInUse",
                    "stock-transfer"
                  )}/review/${this.model.Code}`,
                })
                .then(() => {
                  this.showLoading(true);
                  this.refreshView();
                  this.loaded = false;
                  this.initialized();
                });
            } else this.initialized();
          })
          .catch((err) => {
            this.loaded = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Cancel Stock Transfer Failed",
            });
          });
      }
    },
    onCopyClickHandle() {
      this.$router
        .push({
          path: `/stock-transfer-v2/create/${this.baseView.id}`,
          query: {
            copy: true,
          },
        })
        .then(() => {
          this.showLoading(true);
          this.refreshView();
          this.loaded = false;
          this.initialized();
        });
    },
    /**
     * Go To First Row
     */
    goToFirstRow() {
      const dataGrid = this.dataGrid;
      const i = this.dataSourceProductEntry._array.findIndex(
        (x) => !x.ProductCode
      );
      if (i !== -1) {
        const rowIndex = dataGrid.getRowIndexByKey(
          this.dataSourceProductEntry._array[i].ID
        );
        setTimeout(() => {
          this.focusOnEditableCell(rowIndex);
        }, 50);
      }
    },
    /**
     * Go To Comment Form
     * @param editor
     */
    goToCommentForm(editor = "Comment5") {
      const headerCommentsForm =
        this.$refs["gc-header-comments"].$refs["gc-form-comp"].instance;
      if (headerCommentsForm) {
        headerCommentsForm.getEditor(editor).focus();
      }
    },
    /**
     * focus on editable cell by rowindex
     */
    focusOnCellByRowIndex(row, dataField) {
      const dataGrid = this.dataGrid;
      let rowIndex = dataGrid.getRowIndexByKey(row.ID);
      if (rowIndex !== -1) {
        this.focusOnEditableCell(rowIndex, dataField);
      }
    },
    /**
     * on product search model closing
     */
    onProductSearchHidden() {
      this.visibleProductSearch = false;
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          // this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    formContentReady() {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      // this.headerDxFormHeight = e.element.offsetHeight;
      // setTimeout(() => {
      //   var BranchEditor = e.component.getEditor("BranchCode");
      //   if (BranchEditor) BranchEditor.focus();
      // }, 100);
    },
    async onFromBranchValueChanged(e) {
      if (!e.event) return;

      let itemWithQtyExists = this.dataSourceProductEntry._array.find(
        (x) => x.TransferQty > 0
      );

      if (itemWithQtyExists) {
        let confirmFromBranchChange = await this.$confirm(
          `All product transfer information will be lost if the branch is changed. Do you want to continue?`,
          "Stock Transfer"
        );

        if (confirmFromBranchChange) {
          await this.$store.dispatch("dataContext/setReviewDataSource", []);
          this.productEntryLocalItems = [productEntryBase];
          this.model.BranchCode = e.value;

          this.refreshAllData(true);

          this.dataSourceProductEntry._array.forEach((element) => {
            element.TransferQty = 0;
            element.StockEnquiryQuantities.forEach((stockItem) => {
              if (stockItem.BranchCode === this.model.BranchCode) {
                element.Onhand = stockItem.OnHand;
              }
            });
          });

          this.dataGrid.refresh(true);
        } else {
          if (this.baseView.mode !== "edit")
            this.model.BranchCode = e.previousValue;
          else {
            e.component.beginUpdate();
            e.component.option("value", e.previousValue);
            e.component.endUpdate();
          }
        }
      } else {
        this.model.BranchCode = e.value;

        this.refreshAllData();

        this.dataGrid.refresh(true);
      }
    },
    refreshAllData(isReset = false) {
      this.dataSourceProductEntry._array.forEach((element) => {
        element.TransferQty = 0;
        element.StockEnquiryQuantities.forEach((stockItem) => {
          if (stockItem.BranchCode === this.model.BranchCode) {
            element.Onhand = stockItem.OnHand;
          }
        });
        if (element.IsBatchProduct !== "No") {
          element.ChildDataSource._array.map(async (batch) => {
            const batchItems = await this.getConsumeProductBatch(
              element.ProductCode,
              batch.BatchNo,
              this.model.BranchCode
            );
            if (batchItems.data.value.length > 0) {
              if (isReset) {
                batch.Transfer = 0;
              }
              this.setBatch(batch, batchItems, element);
            }
          });
        }
      });
    },
    /**
     * Triggers on branch value selection changed
     * @param e - selected data item
     */
    onBranchSelectionChanged(e) {
      if (e.selectedItem) {
        this.model.BranchDescription = e.selectedItem.Description;
      }
    },
    // async refreshAllItems() {
    //   const products = this.dataSourceProductEntry._array.filter(
    //       (item) => typeof item.ProductCode !== "undefined"
    //   );
    //   products.map(async (product) => {
    //       const originProduct = await ProductService.getByCodeExpand(product.ProductCode);
    //       if(originProduct.data.value.length > 0){
    //
    //       }
    //   })
    // },
    // DataGrid
    onProductCodeSelected(e) {
      if (e.selectedItem.Code !== null) {
        const index = this.productDataSourceItems.findIndex(
          (x) => x.Code === e.selectedItem.Code
        );
        if (index === -1) {
          this.productDataSourceItems.push(e.selectedItem);
        }
      }

      this.selectedProduct = e.selectedItem;
    },
    onEnterProductCode(e, lineData) {
      if (onEnter(e) || forwardTabbing(e)) {
        setTimeout(() => {
          if (lineData && !lineData.data.ProductCode) {
            this.setValidationComeBack("ProductCode", lineData.rowIndex);
            this.displayValidationErrors(["Product is required"]);
          } else if (lineData.data.IsBatchProduct !== "No") {
            this.focusOnEditableCell(lineData.rowIndex, "Comment");
          } else {
            this.focusOnEditableCell(lineData.rowIndex, "TransferQty");
          }
        }, 100);
        if (lineData.data.IsBatchProduct !== "No") {
          this.getDataGridInstance().expandRow(lineData.data.ID);
        }
      }
    },
    moveOnEnterKey(e, lineData) {
      if (onEnter(e) || forwardTabbing(e)) {
        e.event.preventDefault();
        if (lineData && !lineData.data.ProductCode) {
          this.setValidationComeBack("ProductCode", lineData.rowIndex);
          this.displayValidationErrors(["Product is required"]);
        }
        // TODO : need to address later
        // else if (lineData && lineData.data.TransferQty === 0) {
        //   this.setValidationComeBack("TransferQty", lineData.rowIndex);
        //   this.displayValidationErrors(["Please specify a quantity"]);
        // }
        if (lineData.column.dataField === "Comment") {
          if (lineData.data.IsBatchProduct !== "No") {
            this.BatchGridInstance = this.getMasterDataInstance(
              lineData.data.ID
            );
            this.focusOnBatchEditableCell(0, "BatchNo");
          } else {
            const nextIndex = this.getNextIndex(
              this.getDataGridInstance(),
              this.dataSourceProductEntry._array,
              "ID",
              lineData.data.ID
            );
            this.focusOnEditableCell(nextIndex, "ProductCode");
          }
        }
      } else if (backwardTabbing(e)) {
        e.event.preventDefault();
        if (lineData.column.dataField === "Comment") {
          if (lineData.data.IsBatchProduct !== "No") {
            setTimeout(() => this.focusOnEditableCell(lineData.rowIndex), 100);
          } else {
            setTimeout(
              () => this.focusOnEditableCell(lineData.rowIndex, "TransferQty"),
              100
            );
          }
        }
      }
    },
    focusParentByID(parentData, col) {
      const dataGrid = this.dataGrid;
      let index,
        rowIndex = -1;
      index = this.dataSourceProductEntry._array.findIndex(
        (x) => !x.ProductCode
      );
      if (index !== -1) {
        rowIndex = dataGrid.getRowIndexByKey(parentData.ID);
        setTimeout(() => {
          this.focusOnEditableCell(rowIndex, col);
        }, 50);
      }
    },
    focusOnEditableCell(rowIndex, col) {
      const column = col ? col : "ProductCode";
      const dataGrid = this.dataGrid;
      const cellElement = dataGrid.getCellElement(rowIndex, column);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, column);
      }, 10);
    },
    async addNewRowByPosition(e, type) {
      if (!e.row.data.ProductCode) {
        this.setValidationComeBack("ProductCode", e.row.rowIndex);
        this.displayValidationErrors(["Product Code is required"]);
      } else {
        let dataObj = undefined;
        let maxID = Math.max(
          ...this.dataSourceProductEntry._array.map((e) => e.ID)
        );

        if (type === "add-line") {
          dataObj = Object.assign({ IsNewLine: true }, { ...productEntryBase });
        } else {
          dataObj = Object.assign({ ...e.row.data });
        }
        dataObj.ID = ++maxID;

        this.changes = [
          {
            type: "insert",
            data: dataObj,
            insertAfterKey: e.row.key,
          },
        ];

        this.dataGrid.clearSelection();
        this.dataGrid.option("focusedRowIndex", -1);

        setTimeout(() => {
          this.dataGrid.saveEditData();
          this.dataGrid.refresh(true);
        }, 250);
      }
    },
    onRowRemoved(e) {
      if (this.dataSourceProductEntry._array.length === 0) {
        setTimeout(() => {
          this.addNewRow();
          e.component.refresh();
        }, 10);
      } else {
        const lineData =
          this.dataSourceProductEntry._array[
            this.dataSourceProductEntry._array.length - 1
          ];
        if (lineData) {
          const batchKey = this.dataGrid.getRowIndexByKey(lineData.ID);
          if (batchKey !== -1) {
            this.focusOnEditableCell(batchKey);
          }
        }
      }
    },
    onBatchRowRemoved(e) {
      const lineParent = this.dataSourceProductEntry._array.find(
        (item) => item.ID === e.data.ParentID
      );
      this.updateParent(e.data.ParentID);
      if (lineParent.ChildDataSource._array.length === 0) {
        this.addNewBatchLine(lineParent);
      } else {
        const currentBatchData =
          lineParent.ChildDataSource._array[
            lineParent.ChildDataSource._array.length - 1
          ];
        if (currentBatchData) {
          const batchKey = this.BatchGridInstance.getRowIndexByKey(
            currentBatchData.BatchLineNo
          );
          if (batchKey !== -1) {
            this.focusOnBatchEditableCell(batchKey);
          }
        }
      }
    },
    addNewRow(isFocus = true) {
      let maxID = Math.max(
        ...this.dataSourceProductEntry._array.map((e) => e.ID)
      );
      let dataObj = Object.assign(productEntryBase);
      if (maxID > 0) dataObj.ID = ++maxID;
      else dataObj.ID = 1;

      this.dataSourceProductEntry.insert(dataObj);
      setTimeout(() => this.getDataGridInstance().collapseRow(dataObj.ID), 100);
      if (isFocus) {
        setTimeout(() => {
          const rowIndex = this.getDataGridInstance().getRowIndexByKey(
            dataObj.ID
          );
          this.focusOnEditableCell(rowIndex);
        }, 50);
      }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: () => {
            this.visibleProductSearch = true;
          },
          visible: this.baseView.mode !== "review",
        },
      });
      if (this.baseView.mode === "review") {
        e.toolbarOptions.items.push({
          location: "before",
          widget: "dxButton",
          options: {
            icon: this.expandChildGrid ? "chevronup" : "chevrondown",
            text: this.getLabel,
            onClick: () => {
              this.expandMasterDetailsSection();
            },
            onContentReady: (e) => {
              this.CollapseBtnContentReady = e;
            },
            visible: this.IsBatchAvailable,
          },
        });
      }
    },
    /**
     *
     */
    expandMasterDetailsSection() {
      let gridInstance = this.getDataGridInstance();

      let items = this.dataSourceProductEntry._array;
      this.expandChildGrid = !this.expandChildGrid;
      if (this.expandChildGrid) {
        // gridInstance.collapseAll(-1);
        items.forEach((element, index) => {
          if (
            element.ChildDataSource &&
            element.ChildDataSource._array.length > 0
          ) {
            setTimeout(() => {
              gridInstance.collapseRow(element.LineNo);
            }, 100 * index);
          }
        });
      } else {
        items.forEach((element, index) => {
          if (
            element.ChildDataSource &&
            element.ChildDataSource._array.length > 0
          ) {
            setTimeout(() => {
              gridInstance.expandRow(element.LineNo);
            }, 500 * index);
          }
        });
      }
      setTimeout(() => {
        gridInstance.refresh(true).then(() => {
          if (this.CollapseBtnContentReady) {
            this.CollapseBtnContentReady.component.beginUpdate();
            this.CollapseBtnContentReady.component.option(
              "text",
              this.getLabel
            );
            this.CollapseBtnContentReady.component.option(
              "icon",
              this.expandChildGrid ? "chevronup" : "chevrondown"
            );
            this.CollapseBtnContentReady.component.endUpdate();
          }
        });
      }, 100);
    },
    /**
     *
     */
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.dataGrid;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },
    onContentReady(e) {
      // setTimeout(() => {
      //   this.$store.dispatch(
      //     "ui/headerFormHeight",
      //     this.$refs["gc-header-form-component"].$el.clientHeight
      //   );
      // }, 50);

      if (e && this.gridDataLoaded === false) {
        this.gridDataLoaded = true;
        setTimeout(() => {
          this.expandMasterDetailsSection();
        }, 500);
      }
      if (this.baseView.mode === "edit") e.component.refresh(true);
    },
    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        const change = e.changes[0];
        if (change.insertAfterKey !== undefined) {
          const element = change.data;
          let index = -1;

          index = this.dataSourceProductEntry._array.findIndex(
            (x) => x.ID === change.insertAfterKey
          );
          this.dataSourceProductEntry._array.splice(
            this.dataSourceProductEntry._array.length - 1,
            1
          );
          this.dataSourceProductEntry._array.splice(index + 1, 0, element);

          if (index !== -1)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1);
            }, 100);
        }
      }
    },
    setValidationComeBack(key, field) {
      this.validationLineKey = key;
      this.validationDataField = field;
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode !== "review" && e.parentType !== "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            if (onEnter(event) || forwardTabbing(event)) {
              this.goToNextEditableComponent(e.row, e.name);
              event.event.preventDefault();
            } else if (backwardTabbing(event)) {
              event.event.preventDefault();
              this.goToPrevEditableComponent(e.row, e.name);
            }
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (this.baseView.mode !== "review" && e.parentType !== "searchPanel")
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.dataField && e.dataField === "ProductCode") {
        e.editorName = "dxSelectBox";
      }

      if (e.rowType === "data") {
        // if (e.column.dataField === "TransferQty") {
        //   if (e.data.TransferQty > e.data.Onhand) {
        //     e.cellElement.classList.add("gc-require-validation");
        //   }
        // }
      }
    },
    /**
     * on data grid onEditingStart
     */
    onEditingStart(e) {
      let data = e.data;

      if (e.column.dataField === "TransferQty") {
        if (data.Onhand < 0 || data.IsBatchProduct !== "No") {
          e.cancel = true;
        }
      }
    },
    /**
     * data grid cell focus changing event
     * if the onhand value it less than 0, (editor is disabled) it skips the tab key focus event
     */
    onFocusedCellChanging() {
      // if (e.event && e.newColumnIndex === 4) {
      //   if (e.rows[e.newRowIndex].data.Onhand < 0) {
      //     if (forwardTabbing(e)) e.newColumnIndex = 5;
      //     if (backwardTabbing(e)) e.newColumnIndex = 0;
      //   }
      // }
    },
    /**
     * data grid on cell prepared event
     * @param e
     */
    onCellPrepared(e) {
      if (e.rowType === "data" && this.baseView.mode !== "review") {
        if (e.column.dataField === "TransferQty") {
          if (e.data.TransferQty > e.data.Onhand) {
            e.cellElement.classList.add("gc-require-validation");
          }
        }
      }

      if (e.rowType === "data" && e.column.command === "expand") {
        let removeBatchExpand = false;
        if (
          e.data.IsBatchProduct === "Auto" &&
          e.data.IsVisibleBatchData !== undefined
        ) {
          if (e.data.IsVisibleBatchData === true) removeBatchExpand = false;
        }

        if (e.data.IsBatchProduct === "No" || removeBatchExpand) {
          if (e.cellElement && e.cellElement.classList) {
            e.cellElement.classList.add("gc-datagrid-expand");
            e.cellElement.classList.remove("dx-datagrid-expand");
            if (e.cellElement.childNodes[0].style) {
              e.cellElement.childNodes[0].style.display = "none";
            }
          }
        }
      }
    },
    // Footer
    async setFooterItems(gridItems) {
      // this.showFooter = false;
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode === "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude === undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
    // END
    // Save PO
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        await this.saveStockTransfer(this.model);
      }
    },
    async saveStockTransfer() {
      if (this.getSavePayload().NextStatus === "X") {
        await this.onCancelClickHandle();
      } else {
        if (!this.model.ToBranchCode) {
          await this.$alert(
            "Stock Transfer has no a branch destination. Please choose the branch destination before attempting to save the transaction again.",
            "Warning"
          );
          const instance =
            this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
          instance.getEditor("ToBranchCode").focus();
        } else if (this.getSavePayload().StockTransferDetails.length === 0) {
          await this.$alert(
            "Stock Transfer has no detail. Please add one or more lines before attempting to save the transaction again.",
            "Warning"
          );
          this.goToFirstRow();
        } else {
          this.showLoading(true);
          await StockTransferService.save(
            this.getSavePayload(),
            this.model.Code
          )
            .then((res) => {
              this.showLoading(false);

              if (this.baseView.mode === "create") {
                this.model.Code = res.data.Code;
              }

              if (this.getSavePayload().NextStatus === "X") {
                this.$notify(
                  `Cancellation of Stock Transfer ${this.model.Code} is successful`,
                  "success"
                );
              } else {
                this.$notify(
                  `Stock Transfer ${this.model.Code} Successfully Saved`,
                  "success"
                );
              }

              this.setIgnoreRouteChangeConfirmation();
              this.$router
                .push({
                  path: `/${this.getScreenRowClickNavigation(
                    "StockTransferVersionInUse",
                    "stock-transfer"
                  )}/review/${this.model.Code}`,
                })
                .then(() => {
                  this.showLoading(true);
                  this.refreshView();
                  this.loaded = false;
                  this.initialized();
                });
            })
            .catch((error) => {
              this.showLoading(false);
              this.displayServerError(error, "Save stock transfer Failed");
              this.reFetchAllData();
            });
        }
      }
    },
    reFetchAllData() {
      this.dataSourceProductEntry._array.map(async (product) => {
        const sourceProduct = await ProductService.getByCodeExpand(
          product.ProductCode
        );
        if (sourceProduct.data.value.length > 0) {
          this.setRowProduct(
            product,
            sourceProduct.data.value[0],
            product,
            false
          );
          // const batch = this.setBatchProduct(batchIndex, i, element)
          // this.dataSourceProductEntry.update(product.ID, product)
        }
        if (product.IsBatchProduct !== "No") {
          product.ChildDataSource._array.map(async (batchItem, batchIndex) => {
            const batchItems = await this.getConsumeProductBatch(
              product.ProductCode,
              batchItem.BatchNo,
              this.model.BranchCode
            );

            if (batchItems.data.value.length > 0) {
              this.setBatchProduct(
                batchIndex,
                batchItems.data.value[0],
                product,
                batchItem
              );
            }
          });
        }
      });
      setTimeout(() => this.dataGrid.refresh(), 1000);
    },
    getSavePayload() {
      let payload = {
        Code: this.baseView.id,
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        BranchCode: this.model.BranchCode,
        ToBranchCode: this.model.ToBranchCode,
        NextStatus: this.model.NextStatus === "C" ? "A" : this.model.NextStatus,
        ConsignmentNo: this.model.ConsignmentNo,
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.Status,
        StockTransferDetails: this.getStockTransferDetailPayload(),
        DeliveryInstruction1: this.model.DeliveryInstruction1,
        DeliveryInstruction2: this.model.DeliveryInstruction2,
        Comment1: this.model.Comment1,
        Comment2: this.model.Comment2,
        Comment3: this.model.Comment3,
        Comment4: this.model.Comment4,
        Comment5: this.model.Comment5,
      };

      delete payload.Status;
      if (this.baseView.mode === "create") delete payload.Code;
      return payload;
    },
    getStockTransferDetailPayload() {
      let details = [];

      this.dataSourceProductEntry._array.forEach((data) => {
        if (data.ProductCode) {
          let detailObj = {
            TransferQty: data.TransferQty,
            ItemCode: data.ProductCode,
            Comment: data.Comment,
            StockTransferProductBatches: [],
          };
          if (data.IsBatchProduct !== "No") {
            detailObj.StockTransferProductBatches =
              this.getProductBatchDetailsPayload(data.ChildDataSource._array);
          }
          details.push(detailObj);
        }
      });

      return details;
    },
    getProductBatchDetailsPayload(batches) {
      let batchPayload = [];
      batches.forEach((batch) => {
        let batchObj = {
          TransferQty: batch.Transfer,
          BatchNo: batch.BatchNo,
          Comment: batch.Comment || "",
          SupplierCode: batch.SupplierCode,
        };

        if (batch.BatchNo && batch.Transfer) batchPayload.push(batchObj);
      });

      return batchPayload;
    },
    async initialized() {
      let isCopy = false;
      if (this.baseView.query) {
        if (this.baseView.query.copy === "true") {
          isCopy = true;
        }
      }
      this.changes = [];
      this.dataSourceProductEntry.clear();
      await this.setBranchDataSourceItems();
      if (this.baseView.mode === "create" && !isCopy) {
        for (let index = 0; index < 1; index++) {
          let dataObj = Object.assign(productEntryBase);

          dataObj.ID = index + 1;
          dataObj.IsValid = true;

          this.dataSourceProductEntry.insert({ ...dataObj });
        }

        // this.getProductItems();
        await this.setActiveAccountingPeriod();
        await this.$store.dispatch("screenFactors/getFactors", [65]);
        this.defaultBranchCode = getFactorByCode(65).Factorc;

        this.model.BranchCode = getFactorByCode(65).Factorc;

        this.reload = false;
        this.loaded = true;
      } else {
        let editTransferQtyValidation = false;

        if (
          this.baseView.mode === "edit" ||
          (this.baseView.mode === "create" && isCopy)
        ) {
          // this.getProductItems();
          await this.setActiveAccountingPeriod();
        }
        const record = await StockTransferService.getByCode(this.baseView.id);
        if (record && record.data.value.length > 0) {
          this.model = record.data.value[0];
          if (isCopy) {
            this.model.DateIn = new Date();
            this.model.Code = null;
            this.model.Status = "P";
          }
          this.ellipsisMenu = [
            {
              menuText: "Copy",
              visible:
                this.model.Status === "P" ||
                this.model.Status === "C" ||
                this.model.Status === "X",
            },
            {
              menuText: "Cancel",
              visible: this.model.Status === "P",
            },
          ];
        }

        let detailRecord =
          await StockTransferService.getStockTransferDetailsByCode(
            this.baseView.id,
            {
              expand:
                "Product($select=Code,StockEnquiryQuantities;$expand=StockEnquiryQuantities)",
            }
          );

        if (detailRecord && detailRecord.data.value.length > 0) {
          const data = detailRecord.data.value;
          const IDs = [];
          await data.forEach((element, i) => {
            element.ProductCode = element.ItemCode;
            element.ProductDescription1 = element.ItemDescription;
            element.ID = i + 1;
            element.IsValid = true;

            element.Product.StockEnquiryQuantities.forEach((stockItem) => {
              if (stockItem.BranchCode === this.model.BranchCode) {
                element.Onhand = stockItem.OnHand;
              }
            });

            if (element.TransferQty > element.Onhand) {
              editTransferQtyValidation = true;
              element.IsValid = false;
            }

            var index = this.productDataSourceItems.findIndex(
              (x) => x.Code === element.ItemCode
            );

            if (index !== -1) {
              var data = this.productDataSourceItems[index];

              element.StockEnquiryQuantities = data.StockEnquiryQuantities;

              element.StockEnquiryQuantities.forEach((stockItem) => {
                if (stockItem.BranchCode === this.model.BranchCode) {
                  element.Onhand = stockItem.OnHand;
                }
              });
            }
            if (element["IsBatchProduct"] !== "No") {
              IDs.push(element.ID);
              this.IsBatchAvailable = true;
              element["IsVisibleBatchData"] = true;
              element.AdjustedQty = 0;
              element["ChildDataSource"] = new ArrayStore({
                key: "BatchLineNo",
                data: [],
              });
              StockTransferService.getProductBatches(
                element["ProductCode"],
                element["LineNo"],
                element["StockTransferCode"]
              ).then((batchData) => {
                batchData.data.value.forEach((i, batchIndex) => {
                  const batch = Object.assign({ ...batchItemBase });
                  this.setBatchProduct(batchIndex, i, element, batch);
                  if (batch.Transfer > batch.OnHand) {
                    editTransferQtyValidation = true;
                  }
                  element.ChildDataSource.insert(batch);
                });
              });
            }
            this.dataSourceProductEntry.insert(element);
          });
        }
        this.loaded = true;
        if (this.baseView.mode === "edit" || isCopy) {
          this.addNewRow();

          this.$nextTick(async () => {
            if (editTransferQtyValidation) {
              editTransferQtyValidation = false;
              await this.$alert(
                "One or more items on the this Stock Transfer have inadequate stock to fulfill the Transfer request. Please update the highlighted records.",
                "Warning"
              );
            }
          });
        }
      }

      this.showLoading(false);
      this.expandChildGrid = true;
    },
    setBatchProduct(batchIndex, newBatch, parent, batch) {
      batch.BatchLineNo = batchIndex;
      if (newBatch.BestBeforeDate)
        batch.BestBeforeDate = new Date(newBatch.BestBeforeDate);
      batch.AvailableQty = newBatch.AvailableQty;
      batch.BatchNo = newBatch.BatchNo;
      batch.FromBatchDB = true;
      batch.IsBatchProduct = parent.IsBatchProduct;
      batch.BestBeforeShelfLife = parent.BestBeforeShelfLife;
      if (newBatch.ManufacturedDate)
        batch.ManufacturedDate = new Date(newBatch.ManufacturedDate);
      batch.OnHand = newBatch.OnHand;
      batch.ParentID = parent.ID;
      batch.SupplierBatchNo = newBatch.SupplierBatchNo;
      batch.SupplierCode = newBatch.SupplierCode;
      if (newBatch.TransferQty) {
        batch.Transfer = newBatch.TransferQty;
      }
      if (newBatch.UseByDate) batch.UseByDate = new Date(newBatch.UseByDate);
      batch.UseByShelfLife = parent.UseByShelfLife;

      batch.IsValid = batch.Transfer <= batch.OnHand;
      return batch;
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async setActiveAccountingPeriod() {
      let startDateResult =
        await StockTransferService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateAdjustedMin = new Date(accountingPeriod.StartDate);
      }

      let endDateResult =
        await StockTransferService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateAdjustedMax = new Date(accountingPeriod.EndDate);
      }
    },
    async getProductItems() {
      this.productDataSourceItems = [];
      var totalItemsCount = 0;
      this.showLoading(true);

      await ProductService.getCustomData({
        url: "api/Product",
        count: true,
        top: 1000,
        filter: `Inactive eq 'N' and Status eq 'A'`,
        expand: "StockEnquiryQuantities($select=BranchCode,OnHand,ItemCode)",
        orderby: "Description1 asc",
        select: [
          "Code",
          "Description1",
          "Inactive",
          "IsBatchProduct",
          "UnitOfMeasureCode",
          "StockEnquiryQuantities",
        ],
      }).then((res) => {
        totalItemsCount = res.data["@odata.count"];

        this.productDataSourceItems = this.productDataSourceItems.concat(
          res.data.value
        );

        this.reCallProductItemsList(totalItemsCount, 1000, 1000);
      });
      this.showLoading(false);
    },
    async reCallProductItemsList(totalItemsCount, top, skip) {
      if (skip < totalItemsCount)
        await ProductService.getCustomData({
          url: "api/Product",
          count: true,
          top: top,
          skip: skip,
          filter: `Inactive eq 'N' and Status eq 'A'`,
          expand: "StockEnquiryQuantities",
          orderby: "Description1 asc",
        }).then((res) => {
          this.productDataSourceItems = this.productDataSourceItems.concat(
            res.data.value
          );

          this.reCallProductItemsList(totalItemsCount, 1000, skip + 1000);
        });
      else this.productItemsLoaded = true;
    },
    /**
     * Receive selected product items from search product model
     * @param items
     */
    async setSelectedProducts(items) {
      let isIncluded = false;
      let firstID = undefined;

      items.forEach((element) => {
        let include = this.dataSourceProductEntry._array.findIndex(
          (x) => x.ProductCode === element.Code
        );
        if (!isIncluded) {
          if (include !== -1) isIncluded = true;
        }
        var index = this.dataSourceProductEntry._array.findIndex(
          (x) => !x.ProductCode
        );

        if (index !== -1 && include === -1) {
          var data = this.dataSourceProductEntry._array[index];
          if (!firstID) firstID = data.ID;
          if (!data.ProductCode && data.IsNewLine !== true) this.addNewRow();

          this.setRowProduct(data, element, data);
          data.ProductCode = element.Code;

          this.dataSourceProductEntry.update(data.ID, data);
          if (data.IsBatchProduct !== "No") {
            this.getDataGridInstance().expandRow(data.ID);
          } else {
            this.getDataGridInstance().collapseRow(data.ID);
          }
        }
      });

      if (isIncluded) {
        await this.$alert(
          "You have included one or more products that are already included in this Stock Tranfer. Duplicate products will not be added.",
          "Warning"
        );
      }

      this.dataGrid.refresh().then(() => {
        this.$nextTick(() => {
          if (firstID) {
            var dataGrid = this.dataGrid;
            var rowIndex = dataGrid.getRowIndexByKey(firstID);
            var cellElement = dataGrid.getCellElement(rowIndex, "TransferQty");
            dataGrid.focus(cellElement);
            dataGrid.editCell(rowIndex, "TransferQty");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.class-multiple {
  .dx-selectbox-container .dx-texteditor-container .dx-placeholder {
    color: black;
  }
}

.gc-state-negative .dx-texteditor-input {
  color: red;
}

.alert-row {
  background-color: #ffcccc; /* Light red background */
  color: #a94442; /* Dark red text */
}

.stock-transfer-v2 {
  .edit-cell-datebox-field-border .dx-datebox::after {
    content: "";
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }

  .header-form-container {
    width: 100%;
    display: inline-flex;

    .header-form {
      width: calc((100% / 3) * 2);
      padding-right: 5px;
      margin-bottom: 0 !important;
    }

    .header-comments {
      width: calc((100% / 3) * 1);
      padding-left: 5px;
    }
  }

  .gc-require-validation::after,
  .gc-require-validation .dx-texteditor::after,
  .gc-require-validation.edit-cell-numberbox-field
    .dx-numberbox.dx-texteditor:not(.dx-state-readonly)::after {
    content: "";
    border-bottom: 2px solid rgb(255 0 0) !important;
  }

  //td.gc-require-validation:not(.dx-editor-cell) {
  //  background-color: rgba(255, 0, 0, 0.259) !important;
  //}
  //
  //.dx-datagrid-rowsview
  //  .dx-row-focused.dx-data-row
  //  > td.gc-require-validation:not(.dx-focused) {
  //  background-color: rgba(255, 0, 0, 0.259) !important;
  //}
}
</style>
